<script>
    const axios = require('axios');
    import _ from 'lodash'

    export default {

        props: [
            'searchquery',
            'tagId',
            'tagTitle',
            'scoped',
        ],

        data() {
            return {
                query: '',
                faqs: [],
                tag: {
                    name: 'Alle Kategorien',
                    id: 0,
                },
                sort: {},
                language: "",
            }
        },

        mounted() {
            this.search(this.query);
        },

        watch: {

            query: _.debounce(function() {
                this.search(this.query);
            }, 300),

        },

        methods: {

            search(query) {
                axios.get('/faq/search', {
                    params: {
                        q: query,
                        tagId: this.tag.id
                    }
                }).then(data => {
                    this.faqs = data.data;

                    Vue.nextTick(() => {
                        jQuery('#faqs').collapse({
                            toggle: false
                        })
                    });
                });
            },

            useTag(id, name) {
                this.tag.id = id;
                this.tag.name = name;

                this.search(this.query);
            }
        }
    }
</script>